export const ManagementStructureFactory = (data) => {
    return JSON.parse(data) || [];
}